import { getFragmentData, graphql } from "service/graphql/generated";
import { GetFragmentType, useGraphQLQuery } from "made-this-ui";

export const CurrentUserFragment = graphql(`
  fragment CurrentUserFragment on User {
    id
    name
    email
    isSystemAdministrator
    isAdministrator
    isServiceAdministrator
    isServiceCaseWorker
    locale
    teams {
      id
      name
    }
    serviceTeams(orderBy: name_ASC) {
      id
      name
    }
    __typename
  }
`);

export type CurrentUserFragmentType = GetFragmentType<
  typeof CurrentUserFragment
>;

const CurrentUser_ServiceQuery = graphql(`
  query CurrentUser_Service {
    currentUser {
      ...CurrentUserFragment
    }
  }
`);

export const useCurrentUser = () => {
  const { data } = useGraphQLQuery(CurrentUser_ServiceQuery);
  return getFragmentData(CurrentUserFragment, data?.currentUser)!;
};
